import { useEffect } from 'react';
import Refiner from 'refiner-js';

import { useAuthQuery } from '../auth/hooks/useAuthQuery';

// refiner-js triggers a script load on import via setInstallationMethod('npm').
// If the external script fails (network, ad blocker), the returned promise rejects.
// We catch that rejection here to avoid unhandled promise errors in Bugsnag.
let refinerAvailable = true;

(Refiner('setProject', window.env.RIDEIQ_REFINER_KEY) as unknown as Promise<unknown>)?.catch(() => {
  refinerAvailable = false;
});

export const useRefiner = () => {
  const { user, isImpersonating } = useAuthQuery();

  useEffect(() => {
    if (user && !isImpersonating && refinerAvailable) {
      identifyUser(user);
    }
  }, [user, isImpersonating]);
};

const identifyUser = (user: User) => {
  try {
    (
      Refiner?.('identifyUser', {
        id: user.slug,
        email: user.email,
        metro: user.metroAreaName,
        createdAt: new Date(),
      }) as unknown as Promise<unknown>
    )?.catch(() => {
      // Refiner not available — non-critical, continue without it
    });
  } catch {
    // Refiner not available — non-critical, continue without it
  }
};
